import { useQuery } from "@tanstack/react-query";
import axiosInstance from "@/services/api";
import { VoiceLanguagesResponse } from "types";

const VOICE_LANGUAGES_QUERY_KEY = "voice-languages";

export const useVoiceLanguages = () => {
  return useQuery<VoiceLanguagesResponse>({
    queryKey: [VOICE_LANGUAGES_QUERY_KEY],
    queryFn: async () => {
      const response = await axiosInstance.get<VoiceLanguagesResponse>(
        "/media/voice_profiles/languages"
      );
      return response.data;
    },
    staleTime: Infinity,
  });
};
